module.exports = __webpack_public_path__ + "static/contract-04539f0fbd7c1540bababaaaa408a28f.png";